<template>
  <hm-content :hidden="hidden">
    <div class="table-panel flex">
      <!-- <div class="text-right"> -->
      <el-select
        placeholder="请选择卡名"
        v-model="searchCondition.plusRuleId"
        size="small"
        class="mr10"
        clearable
      >
        <el-option
          v-for="(v, i) in basic_plus_rule_lists"
          :value="v.plusRuleId"
          :label="v.cardName"
          :key="i"
        ></el-option>
      </el-select>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.createTimeArry"
        type="datetimerange"
        align="right"
        start-placeholder="请选择开卡时间段"
        end-placeholder="请选择开卡时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.endTimeArry"
        type="datetimerange"
        align="right"
        start-placeholder="请选择到期时间段"
        end-placeholder="请选择到期时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      ></el-date-picker>
      <!--<el-select
        clearable
        class="mr10"
        size="small"
        style="width:200px"
        v-model="searchCondition.cardStatus"
        placeholder="请选择PLUS卡状态"
        filterable
      >
        <el-option label="注销" :value="0"></el-option>
        <el-option label="正常" :value="1"></el-option>
        <el-option label="冻结" :value="2"></el-option>
      </el-select>-->
      <el-select
        clearable
        class="mr10"
        size="small"
        style="width: 200px"
        v-model="searchCondition.cardTimeStatus"
        placeholder="请选择PLUS卡状态"
        filterable
      >
        <el-option label="正常" :value="1"></el-option>
        <el-option label="已过期" :value="2"></el-option>
      </el-select>
      <el-input
        clearable
        style="width: 250px"
        class="mr10"
        v-model="searchCondition.keyWords"
        size="small"
        placeholder="请输入卡号/会员名称/手机号"
      ></el-input>
      <el-select
        v-if="plusAssistant.length"
        clearable
        class="mr10"
        size="small"
        v-model="searchCondition.assistant"
        placeholder="专属管家"
        filterable
      >
        <el-option
          :label="v.itemValue"
          :value="v.itemValue"
          v-for="(v, i) in plusAssistant"
          :key="i"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>

      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >

      <!-- </div> -->
    </div>

    <div class="table-panel flex flex-end">
      <el-button
          type="success"
          size="small"
          @click="outputNew"
          :loading="isOutputing"
      >导出PLUS会员列表</el-button
      >
      <el-button
          type="success"
          size="small"
          @click="exportPlusOrder('plusOrderDetail')"
          :loading="isOutputing"
      >导出PLUS会员订单明细</el-button
      >
      <el-button
          type="success"
          v-if="storeCode === '53010017032439'"
          size="small"
          @click="exportPlusOrder('plusCouponOrderDetail')"
          :loading="isOutputing"
      >导出PLUS消费返利订单明细</el-button
      >
    </div>

    <div class="table">
      <el-table
        :data="plusMemberList.records"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" label="会员信息" prop="cardNo">
          <template slot-scope="scope">
            <div>卡号：{{ scope.row.cardNo }}</div>
            <div>名称：{{ scope.row.realName }}</div>
            <div>电话：{{ scope.row.mobile }}</div>
            <div>绑定卡：{{ scope.row.cardNo }}</div>
            <div>宝宝生日：{{ scope.row.babyBirthday }}</div>
            <div v-if="plusAssistant.length">
              专属管家：
              <el-select
                clearable
                class="mr10"
                size="mini"
                v-model="scope.row.assistant"
                placeholder="请选择专属管家"
                filterable
                @change="assistantChange(scope.row)"
              >
                <el-option
                  :label="v.itemValue"
                  :value="v.itemValue"
                  v-for="(v, i) in plusAssistant"
                  :key="i"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" label="plus卡状态" prop="cardNo">
          <template slot-scope="scope">
            <div v-if="scope.row.timeDay <= 0">
              <el-tag effect="plain" size="small" type="danger">已过期</el-tag>
            </div>
            <div v-else>
              <el-tag
                effect="plain"
                size="small"
                v-if="scope.row.cardStatus === '0'"
                type="danger"
                >注销</el-tag
              >
              <el-tag
                size="small"
                effect="plain"
                v-else-if="scope.row.cardStatus === '1'"
                >正常</el-tag
              >
              <el-tag
                effect="plain"
                size="small"
                v-else-if="scope.row.cardStatus === '2'"
                type="info"
                >冻结</el-tag
              >
            </div>

            <div>开卡时间：{{ scope.row.cardTermStartTime }}</div>
            <div>到期时间：{{ scope.row.cardEndDate }}</div>
            <div>
              剩余天数：
              <span class="expired" v-if="scope.row.timeDay <= 0">0</span>
              <span class="current" v-else> {{ scope.row.timeDays }}</span>
            </div>
            <div v-if="scope.row.plusCardInfo.length">
              卡名：
              <el-popover
                placement="right"
                width="450"
                trigger="hover"
                :popper-options="{ boundariesElement: 'viewport', placement: 'right' }"
              >
                <div style="padding: 10px;">
                  <div v-for="(card, index) in sortedPlusCards(scope.row.plusCardInfo)" :key="index" class="card-item" style="margin-bottom: 8px;">
                    <div class="plus-card" style="padding: 8px;">
                      <div class="card-header" style="margin-bottom: 4px;">
                        <span class="card-type" style="font-weight: bold; margin-right: 8px;">PLUS卡</span>
                        <span class="card-name">{{ card.plusCardName }}</span>
                      </div>
                      <div class="card-content" style="margin-left: 50px;">
                        <span :class="getCardTimeStatus(card.cardTermStartTime, card.cardTermEndTime)" class="card-validity" style="font-size: 13px;">
                          {{ card.cardTermStartTime }}至{{ card.cardTermEndTime }}
                        </span>
                      </div>
                      <!-- 显示关联的联名卡 -->
                      <div v-if="getRelatedJointCards(card, scope.row.plusCardInfo).length > 0" class="joint-cards" style="margin-top: 8px; margin-left: 15px;">
                        <div v-for="(jointCard, jointIndex) in getRelatedJointCards(card, scope.row.plusCardInfo)" :key="jointIndex" class="joint-card-item" style="padding: 6px; margin-top: 4px;">
                          <div class="card-header" style="margin-bottom: 2px;">
                            <span class="card-type" style="font-weight: bold; margin-right: 8px;">联名卡</span>
                            <span class="card-name">{{ jointCard.plusCardName }}</span>
                          </div>
                          <div class="card-content" style="margin-left: 50px;">
                            <span :class="getCardTimeStatus(jointCard.cardTermStartTime, jointCard.cardTermEndTime)" class="card-validity" style="font-size: 13px;">
                              {{ jointCard.cardTermStartTime }}至{{ jointCard.cardTermEndTime }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template slot="reference">
                  <div class="card-names-container" style="border: 1px solid #e4e7ed; border-radius: 4px; padding: 10px; display: inline-block; cursor: pointer;">
                    <el-tag
                      v-for="(v, i) in scope.row.plusCardInfo"
                      :key="i"
                      :style="{
                        borderColor: getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'expired' ? '#d9d9d9' : 
                                   getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'current' ? '#28a745' : '#ffc107',
                        color: getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'expired' ? '#909399' : 
                               getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'current' ? '#28a745' : '#ffc107',
                        backgroundColor: getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'expired' ? '#f5f7fa' : 
                                         getCardTimeStatus(v.cardTermStartTime, v.cardTermEndTime) === 'current' ? '#e8f5e8' : '#fff9c4',
                        marginRight: '10px',
                        marginBottom: '10px'
                      }"
                      size="small"
                    >
                      {{ v.plusCardName }}
                    </el-tag>
                  </div>
                </template>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          label="费用信息"
          prop="cardNo"
          width="200"
        >
          <template slot-scope="scope">
            <div>购卡费用：{{ ToFixed(scope.row.openCardFee, 2) }}</div>
            <div>本月余额：{{ ToFixed(scope.row.couponBalance || 0, 2) }}</div>
            <el-tooltip placement="top" v-if="isHasHuaChuang">
                <div slot="content">
                    <div v-html="
                      '华创总额:' +
                      scope.row.factSalesBalance +
                      ' + 服务总额:'
                        + (scope.row.memberConsumptionInfo
                        ? scope.row.memberConsumptionInfo.服务总额
                        : '0') +
                      ' + 零售提货总额:'
                        + (scope.row.memberConsumptionInfo
                        ? scope.row.memberConsumptionInfo.零售提货总额
                        : '0') +
                      ' - 零售退款总额:'
                        + (scope.row.memberConsumptionInfo
                        ? scope.row.memberConsumptionInfo.零售退款总额
                        : '0') +
                      ' + 零售销售总额:'
                        + (scope.row.memberConsumptionInfo
                        ? scope.row.memberConsumptionInfo.零售销售总额
                        : '0') +
                      ' + 预售实际总额:'
                        + (scope.row.memberConsumptionInfo
                        ? scope.row.memberConsumptionInfo.预售实际总额
                        : '0') +
                      ' = 开卡累计消费:'
                        +  ToFixed(
                              scope.row.totalConsumeAmount + scope.row.factSalesBalance,
                              2
                            )
                    "></div>
                </div>
                <div>
                  开卡累计消费：{{
                    ToFixed(
                      scope.row.totalConsumeAmount + scope.row.factSalesBalance,
                      2
                    )
                  }}
                </div>
            </el-tooltip>
            <div v-else>
              开卡累计消费：{{
                ToFixed(
                  scope.row.totalConsumeAmount + scope.row.factSalesBalance,
                  2
                )
              }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          label="孕产信息"
          prop="cardNo"
          width="400px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.familyInfoVoList.length">
              <div class="flex">
                <div class="flex-1 flex  flex-center">
                  成员关系
                </div>
                <div class="flex-1 flex  flex-center">
                  姓名
                </div>
                <div class="flex-2 flex  flex-center">
                  生日
                </div>
              </div>
              <div
                class="flex"
                v-for="(v, i) in scope.row.familyInfoVoList"
                :key="i"
              >
                <div class="flex-1 flex  flex-center">
                  {{ v.familyRelation === "male" ? "男" : "女" }}
                </div>
                <div class="flex-1 flex flex-center">
                  {{ v.familyName }}
                </div>
                <div class="flex-2 flex flex-center">
                  {{ v.familyBirthday }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="PLUS卡号"
          prop="cardNo"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="timeDay"
          label="剩余时间(天)"
        >
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.timeDay < 0">已过期</span>
            <span v-else> {{ scope.row.timeDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardTermStartTime"
          label="开卡时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardTermEndTime"
          label="到期时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="openCardFee"
          label="购卡费用"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponBalance"
          label="本月剩余额度"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStatus"
          label="PLUS状态"
        >
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.cardStatus === '0'">注销</span>
            <span class="success" v-if="scope.row.cardStatus === '1'"
              >正常</span
            >
            <span class="danger" v-if="scope.row.cardStatus === '2'">冻结</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="240"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                type="text"
                size="small"
                @click="queryDetails(scope.row)"
              >
                查看
              </el-button>
              <el-button
                v-if="hasJointCards(scope.row.plusCardInfo)"
                type="text"
                size="small"
                @click="showRightsProgress(scope.row)"
              >
                查看联名卡明细
              </el-button>
              <el-button
                type="text"
                size="small"
                :class="scope.row.timeDay <= 0 ? 'gray' : ''"
                @click="toDetails(scope.row)"
                :disabled="scope.row.timeDay <= 0"
              >
                调整优惠券额度
              </el-button>
            </div>
            <div class="flex flex-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                :class="scope.row.timeDay <= 0 ? 'gray' : 'blue'"
                :disabled="scope.row.timeDay <= 0"
                @click="transfer(scope.row)"
              >
                权益转移
              </el-button>
              <el-button
                type="text"
                :class="scope.row.timeDay <= 0 ? 'gray' : 'danger'"
                size="small"
                :disabled="scope.row.timeDay <= 0"
                @click="cancelRights(scope.row)"
              >
                取消权益
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="operationLog(scope.row)"
                >操作日志</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="showRecommendCode(scope.row)"
                >查看推荐码/推荐记录</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table" v-if="false">
      <el-table
        :data="plusMemberList.records"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="PLUS卡号"
          prop="cardNo"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="timeDay"
          label="剩余时间(天)"
        >
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.timeDay < 0">{{
              scope.row.timeDay
            }}</span>
            <span v-else> {{ scope.row.timeDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardTermStartTime"
          label="开卡时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardTermEndTime"
          label="到期时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="openCardFee"
          label="购卡费用"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponBalance"
          label="本月剩余额度"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStatus"
          label="PLUS状态"
        >
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.cardStatus === '0'">注销</span>
            <span class="success" v-if="scope.row.cardStatus === '1'"
              >正常</span
            >
            <span class="danger" v-if="scope.row.cardStatus === '2'">冻结</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="230"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button type="text" size="small" @click="toDetails(scope.row)">
                调整优惠券额度
              </el-button>
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="transfer(scope.row)"
              >
                权益转移
              </el-button>
              <el-button
                type="text"
                class="danger"
                size="small"
                @click="cancelRights(scope.row)"
              >
                取消权益
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="plusMemberList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      custom-class="import-dialog"
      title="已领取未使用的专属会员券"
      width="70%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="
        dialogVisible = false;
        checkCouponsList = [];
      "
    >
      <div class="p20">
        <div class="flex flex-center">
          已领取未使用的专属会员券|会员手机{{ row.mobile }}
        </div>
        <el-checkbox-group
          class="mt20"
          v-model="checkCouponsList"
          @change="checkedCoupons"
        >
          <div>
            <div class="list-item" v-for="(v, i) in list" :key="i">
              <el-checkbox :label="v" class="flex-1 flex item-center">
                <div
                  class="list-box flex flex-wrap"
                  style="width: 500px; height: 110px"
                >
                  <div class="list-left">
                    <span class="zhekou" v-if="v.type === '0'"
                      >{{ v.account.toFixed(2) }}元</span
                    >
                    <!-- <span class="zhekou" v-if="v.type === '1'"
                      >{{ v.discount.toFixed(2) }}折</span
                    > -->
                    <span class="zhekou" v-if="v.type === '3'"
                      >{{ v.discount }}折</span
                    >
                    <span class="zhekou" v-if="v.type === '2'"
                      >{{ v.account.toFixed(2) }}元运费</span
                    >
                    <span class="tiaojian">满{{ v.levelMin }}元可用</span>
                  </div>
                  <div class="list-right">
                    <div class="right-top">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="v.name"
                        placement="top-start"
                      >
                        <div class="right-title">
                          {{ v.name }}
                        </div>
                      </el-tooltip>
                      <div class="right-time">
                        {{ v.startDate }}至{{ v.endDate }}
                      </div>
                      <div class="remaining-time mt10">
                        截止时间：<span>{{ v.endDate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="circle1"></div>
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
        <div class="flex flex-center" v-if="list.length < 1">暂无数据...</div>
        <div class="hm-pagination mb10">
          <el-pagination
            :hide-on-single-page="total === 0"
            background
            :total="total"
            @current-change="pagingCoupons"
            @size-change="handleSizeChangeCoupons"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageCoupons"
          ></el-pagination>
        </div>
        <div class="mt10 flex flex-center mb10">
          <el-button
            size="small"
            type="primary"
            @click="confirm"
            v-if="total > 0"
            >确认礼券回退</el-button
          >
          <el-button
            size="small"
            type="info"
            @click="
              dialogVisible = false;
              checkCouponsList = [];
            "
            >关闭</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleRights"
      @close="cleanData"
    >
      <div slot="title" class="primary" style="fontsize: 18px; fontweight: 600; padding-bottom:10px; border-bottom:solid 1px #EEEEEE;">
        PLUS会员权益{{ type === "transfer" ? "转移" : "取消" }}
        <span class="tips_02 ml20" v-if="type === 'transfer'">将取消该会员的plus会员权益，并将权益转移给以下会员手机号所有者</span>
        <span class="tips_02 ml20" v-if="type === 'cancelRights'">将取消该会员的plus会员线上权益，并将其会员卡变更为默认开卡类型</span>
        <!-- 确认{{ type === "transfer" ? "转移" : "取消" }}会员{{row.mobile}}的权益？ -->
      </div>
      <div v-if="type === 'transfer'">
        <div style="font-size: 16px; line-height: 24px">
          <div class="flex primary">
            重要提示:权益不包含会员卡类型的变更，请联系ERP管理者手动变更
          </div>
          <div
            class="flex flex-center mt20 transfer-list"
          >
            <span class="left">转出会员手机号：</span>
            <span class="right">{{row.mobile}}</span>
          </div>
          <div class="flex flex-center mt20 transfer-list">
            <span class="left"><i class="primary">*</i>接收会员手机号：</span>
            <span class="right">
            <el-input
              clearable
              style="width: 300px"
              v-model.trim="mobile"
              placeholder="请输入新的获得该权益的会员手机号"
              size="small"
              class="ipt mr10"
              oninput="if(value.length>11)value=value.slice(0,11)"
              type="number"
            ></el-input>      
            </span>      
          </div>
          <div
            class="flex flex-center mt20 transfer-list"
          >
            <span class="left">转移备注：</span>
            <span class="right">
            <el-input
              class="remark-tarea"
              size="small"
              type="textarea"
              clearable
              style="width: 340px"
              placeholder="请输入操作备注"
              maxlength="128"
              v-model="remark"
            ></el-input>
            </span>
          </div>
          <div
            class="flex flex-center mt20"
            style="margin-top:50px"
          >
            <el-button type="primary" size="small" @click="searchMember"
                >确认变更</el-button
              >
            <el-button
              @click="dialogVisibleRights = false"
              size="small"
              type="info"
              >取消</el-button
            >  
          </div>  
        </div>
      </div>
      <div v-if="type === 'cancelRights'">
        <div style="font-size: 14px; line-height: 24px" class="mb10">          
          <div class="flex primary">
            重要提示:卡类型变更或有延时，可以联系ERP管理员在后台操作
          </div>
          <div class="flex primary" v-if="tipContent">
            {{tipContent}}
          </div>
        </div>
        <div class="add-table">
          <div
              class="mt20 transfer-list"
              style="border:1px solid #EBEEF5;border-bottom:none;height:40px;line-height:40px;"
            >
              <span style="margin-left:20px;font-size:14px">会员手机号：</span>
              <span style="font-size:14px">{{row.mobile}}</span>
          </div>
          <el-table
            ref="multipleTable"
            :data="normalPlusCardInfo"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            stripe
            size="small"
            border>
            <el-table-column
              type="selection"
              width="55"
              align="center">
            </el-table-column>
             <el-table-column
              prop="openCardAdminId"
              label="订单号"
              align="center">
            </el-table-column>
            <el-table-column
              label="类型"
              align="center">
                <template v-slot="childScope">
                      <span v-if="childScope.row.cardType === 'basic'"
                        >PLUS卡</span
                      >
                      <span v-else>联名卡</span>
                    </template>
            </el-table-column>
            <el-table-column
              prop="cardName"
              label="卡名"
              align="center">
            </el-table-column>
            <el-table-column
              prop="address"
              label="有效期"
              show-overflow-tooltip
              align="center"
              width="270px">
              <template v-slot="childScope">
                      {{ childScope.row.cardTermStartTime }}至{{
                        childScope.row.cardTermEndTime
                      }}
                    </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="flex mt20 transfer-list"
        >
          <span class="left" style="width:auto;font-size:14px;">备注：</span>
          <span class="right">
          <el-input
            class="remark-tarea"
            size="small"
            type="textarea"
            clearable
            style="width: 300px"
            placeholder="请输入操作备注"
            maxlength="128"
            v-model="remark"
          ></el-input>
          </span>
        </div>
        <div class="mt20" v-if="dialogVisibleLabelList">
          <el-checkbox-group
            v-model="labelInfoVosList"
          >
            <el-checkbox
              v-for="(v, i) in detMemberMgt.labelInfoVos"
              :label="v.labelId"
              :key="i"
              >
              <template>
                <el-tag
                  style="margin:5px"
                >
                  {{ v.labelName }}</el-tag
                >
              </template>
              </el-checkbox
            >
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center" style="margin-top:50px">
          <el-button @click="confirmTransfer" size="small" type="primary"
            >取消权益</el-button
          >
          <el-button
            @click="dialogVisibleRights = false"
            size="small"
            type="info"
            >暂不处理</el-button
          >
        </span>
      </div>
      <el-dialog
        width="900px"
        :close-on-click-modal="false"
        title="提示"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          <div class="flex flex-center">
            <span
              class="hmicon icon-tishi"
              style="font-size: 50px; color: rgb(243, 174, 64)"
            ></span>
          </div>

          <div class="flex flex-center" v-if="code === '-1'">
            {{ errmsg }}
          </div>
          <div v-else>
            <div class="flex flex-center">手机号{{ code.memberMobile }}</div>
            <div class="flex flex-center">会员卡{{ code.cardNo }}</div>
            <div class="flex flex-center">将获得plus会员权益</div>
            <div class="flex flex-center" v-if="isDengkang">
              <el-checkbox-group
                class="mt20"
                v-model="moveConsumeInfoList"
                @change="moveConsumeInfoListChange"
              >
              <el-checkbox label="yes" class="flex-1 flex item-center">
                <span class="TransferAmount">转移开卡累计消费:{{ ToFixed(this.row.totalConsumeAmount + this.row.factSalesBalance,2) }}</span>
              </el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="list.length > 0" class="mt20">
              <div class="flex flex-center" style="color: #004af5">
                <span
                  >请选择要转移的优惠券（勾选的优惠券将一并转移要转移的会员）：</span
                >
              </div>
            </div>            
            <el-checkbox-group
              class="mt20"
              v-model="checkCouponsList"
              @change="checkedCoupons"
            >
              <div v-if="list.length > 0">
                <div
                  class="list-item flex-center"
                  v-for="(v, i) in list"
                  :key="i"
                >
                  <el-checkbox :label="v" class="flex-1 flex item-center">
                    <div
                      class="list-box flex flex-wrap"
                      style="width: 550px; height: 110px"
                      :class="`act${v.type}`"
                    >
                      <div class="list-left">
                        <span class="zhekou" v-if="v.type === '0'"
                          >{{ v.account.toFixed(2) }}元</span
                        >

                        <span class="zhekou" v-if="v.type === '3'"
                          >{{ v.discount }}折</span
                        >
                        <span class="zhekou" v-if="v.type === '2'"
                          >{{ v.account.toFixed(2) }}元运费</span
                        >
                        <span class="tiaojian">满{{ v.levelMin }}元可用</span>
                      </div>
                      <div class="list-right">
                        <div class="right-top">
                          <span class="right-title">
                            {{ v.name }}
                          </span>
                          <div class="right-time">
                            {{ v.startDate }}至{{ v.endDate }}
                          </div>
                          <div class="remaining-time mt10">
                            剩余时间：<span>{{ v.djs }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex item-center ml20" v-if="v.useRank !== 1">
                        <el-button
                          size="small"
                          type="text"
                          @click="openCoupon(v)"
                          >打开券码</el-button
                        >
                      </div>
                    </div>
                    <div class="circle1"></div>
                  </el-checkbox>
                </div>
              </div>
              <div class="flex flex-center" v-if="list.length < 1">
                暂无数据...
              </div>
            </el-checkbox-group>
            <div class="hm-pagination mb10">
              <el-pagination
                background
                :total="total"
                @current-change="pagingCoupons2"
                @size-change="handleSizeChange2"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>

          <span
            slot="footer"
            class="dialog-footer flex flex-center mt10"
            v-if="code !== '-1'"
          >
            <el-button @click="confirmTransfer" size="small" type="primary"
              >确认变更
            </el-button>
            <el-button @click="innerVisible = false" size="small" type="info"
              >取消
            </el-button>
          </span>
        </div>
      </el-dialog>
    </el-dialog>
    <hm-member-details
      :visible="visible"
      @close="visible = false"
      :centerId="centerId"
    >
    </hm-member-details>
    <el-dialog
      title="操作日志"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleLog"
      custom-class="sales-volumn-dialog"
    >
      <el-table
        :data="logList"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPageLog - 1) * pageSizeLog + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作人"
          prop="operatorName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作时间"
          prop="operatorTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作行为"
          prop="operatorAction"
        >
          <template slot-scope="scope">
            <div
              class="danger"
              v-if="scope.row.operatorAction === 'rightCancel'"
            >
              取消权益
            </div>
            <div
              class="danger"
              v-else-if="scope.row.operatorAction === 'rightMove'"
            >
              权益转移
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="备注"
          prop="remark"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalLog"
          @current-change="pagingLog"
          @size-change="handleSizeChangeLog"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPageLog"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      width="500px"
      :close-on-click-modal="false"
      :visible.sync="cancelVisible"
    >
      <div slot="title">
        已取消
        <span class="primary">{{ cancelCardInfo.plusCardName }}</span> 卡权益
      </div>
      <div class="mb10">
        已取消会员卡类型：<span>{{
          cancelCardInfo.cardType === "basic" ? "PLUS卡" : "联名卡"
        }}</span>
      </div>
      <div class="mb10">
        已取消会员卡名称：<span>{{ cancelCardInfo.plusCardName }}</span>
      </div>
      <div class="mb10">
        开卡时间：<span>{{ cancelCardInfo.cardTermStartTime }}</span>
      </div>
      <div class="mb10">
        到期时间：<span>{{ cancelCardInfo.cardTermEndTime }}</span>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="dialogVisible2" width="500px">
      <div class="flex flex-center">
        优惠券码: <span class="primary"> {{ couponCode }}</span>
      </div>
    </el-dialog>

      <el-dialog
        title='推荐记录'
        :visible.sync='recommendCodeVisible'
        width='1300px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='recommend-dialog'
      >
        <el-table :data="finalRecommendCodeList"
          style="width: 100%"
          ref="goods"
          stripe
          border
          size="small">
          <el-table-column label="记录ID" prop="recommendId" show-overflow-tooltip></el-table-column>
          <el-table-column label="推荐人手机号" prop="recPlusMobile" show-overflow-tooltip></el-table-column>
          <el-table-column label="推荐码" prop="recommendCode" show-overflow-tooltip></el-table-column>
          <el-table-column label="被推荐人手机号" prop="pointPlusMobile" show-overflow-tooltip></el-table-column>
          <el-table-column label="推荐绑定时间" prop="createTime" show-overflow-tooltip></el-table-column>
          <el-table-column label="规则名称" prop="cardName" show-overflow-tooltip></el-table-column>
          <el-table-column label="优惠券名称" prop="couponSendName" show-overflow-tooltip></el-table-column>
          <el-table-column label="发放状态" prop="status">
            <template slot-scope="scope">
              {{scope.row.status === 'awarded'?'已发放':'已退单'}}
            </template>
          </el-table-column>
          <el-table-column label="退款状态" prop="id"></el-table-column>
          <el-table-column label="回收时间" prop="id"></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="recommendCodeTotal"
            @current-change="pagingRecommendCode"
            @size-change="handleSizeChangeRecommendCode"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="recommendCodeCondition.pageNo"
            :page-sizes='[10, 20, 30, 40, 50]' 
            :page-size="recommendCodeCondition.pageSize"
          ></el-pagination>
        </div>
        <template slot='footer'>
          <el-button @click='recommendCodeVisible = false' type='primary' size='small'>确定</el-button>
        </template>
      </el-dialog>

      <el-dialog
        title='PLUS会员联名卡权益明细'
        :visible.sync='rightsProgressDialogVisible'
        width='70%'
        :close-on-click-modal='false'
        custom-class='rights-progress-dialog'
      >
        <div class="mb10 flex flex-between item-center">
          <span class="gray">会员手机：{{ rightsProgressRow.mobile }}</span>
          <el-button
            type="success"
            size="small"
            :loading="isRightsProgressOutputing"
            @click="exportRightsProgress"
          >导出</el-button>
        </div>
        <el-table
          :data="rightsProgress.cards"
          style="width: 100%"
          stripe
          size="small"
          border
          row-key="cardId"
          :expand-row-keys="expandedCardKeys"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="p10">
                <el-table
                  :data="scope.row.rights"
                  size="mini"
                  stripe
                  border
                  row-key="name"
                  :expand-row-keys="expandedRightKeys"
                >
                  <el-table-column type="expand">
                    <template slot-scope="s2">
                      <div class="p10">
                        <el-table :data="s2.row.coupons" size="mini" stripe border>
                          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                          <el-table-column label="小票号" prop="receiptSn" align="center"></el-table-column>
                          <el-table-column label="商品编码" prop="goodsSn" align="center"></el-table-column>
                          <el-table-column label="商品数量" align="center">
                            <template slot-scope="s3">
                              <span :style="{ color: s3.row.goodsNum < 0 ? '#F56C6C' : '' }">{{ s3.row.goodsNum }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="实际金额" align="center">
                            <template slot-scope="s3">{{ ToFixed(s3.row.actuallyPrice, 2) }}</template>
                          </el-table-column>
                          <el-table-column label="记录时间" prop="createTime" align="center"></el-table-column>
                        </el-table>
                        <div class="tac gray mt10" v-if="!s2.row.coupons || s2.row.coupons.length === 0">暂无消费记录</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="权益名称" prop="name" align="center"></el-table-column>
                  <el-table-column label="目标件数" prop="target" align="center"></el-table-column>
                  <el-table-column label="累计商品数量" align="center">
                    <template slot-scope="s2">
                      <span :style="{ color: s2.row.goodsCount >= s2.row.target ? '#67C23A' : '#F56C6C' }">{{ s2.row.goodsCount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="累计商品金额" align="center">
                    <template slot-scope="s2">{{ ToFixed(s2.row.goodsAmount, 2) }}</template>
                  </el-table-column>
                  <el-table-column label="已派券数量" prop="couponCount" align="center"></el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联名卡" prop="cardName" align="center"></el-table-column>
          <el-table-column label="会员姓名" prop="memberName" align="center"></el-table-column>
          <el-table-column label="归属门店" prop="store" align="center"></el-table-column>
          <el-table-column label="专属管家" prop="guide" align="center"></el-table-column>
          <el-table-column label="联名卡效期" align="center">
            <template slot-scope="scope">{{ scope.row.termStart }} 至 {{ scope.row.termEnd }}</template>
          </el-table-column>
        </el-table>
        <div class="tac gray mt10" v-if="!rightsProgress.cards || rightsProgress.cards.length === 0">暂无数据</div>
        <template slot='footer'>
          <el-button @click='rightsProgressDialogVisible = false' type='primary' size='small'>关闭</el-button>
        </template>
      </el-dialog>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";

function InitTime(endtime) {
  var dd,
    hh,
    mm,
    ss = null;
  var time = new Date(endtime).getTime() - new Date().getTime();

  if (time <= 0) {
    return "结束";
  } else {
    dd = Math.floor(time / 60 / 60 / 24);
    hh = Math.floor((time / 60 / 60) % 24);
    mm = Math.floor((time / 60) % 60);
    ss = Math.floor(time % 60);
    var str = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
    return str;
  }
}
import { setCookie, getCookie, ToFixed } from "@/utils/utils";
import { mapGetters } from "vuex";
import HmMemberDetails from "@/components/HmMemberDetails";
import moment from "moment";
export default {
  components: {
    HmMemberDetails,
  },
  data() {
    return {
      cancelVisible: false,
      ToFixed,
      remark: "",
      logList: [],
      title: "",
      couponCode: "",
      couponsCodes: [],
      couponInfoList: [],
      couponIdList: [],
      currentPageLog: 1,
      pageSizeLog: 10,
      totalLog: 0,
      dialogVisibleLog: false,
      code: "",
      errmsg: "",
      innerVisible: false,
      type: "",
      mobile: "",
      dialogVisibleRights: false,
      dialogVisible: false,
      dialogVisible2: false,
      searchCondition: {
        plusRuleId: "",
        createTimeArry: [],
      },
      currentPage: 1,
      pageSize: 10,
      currentPageCoupons: 1,
      pageSizeCoupons: 10,
      total: 0,
      list: [],
      checkCouponsList: [],
      row: {},
      isOutputing: false,
      centerId: "",
      visible: false,
      plusAssistant: [],
      hidden: true,
      cancelCardInfo: {},
      basic_plus_rule_lists: [],
      detMemberMgt: {
        storeMemberCenterInfoVo: [],
        cardInfoVoList: [],
        familyInfoVoList: [],
        labelInfoVos: [],
      },
      labelInfoVosList: [],
      dialogVisibleLabelList: false,
      storeCode: "",
      isHasHuaChuang: false,
      isDengkang: false,
      moveConsumeInfoList: ["yes"],
      moveConsumeInfo: "yes",
      recommendCodeList: [],
      recommendCodeCondition: {
        pageNo: 1,
        pageSize: 10,
      },
      recommendCodeTotal: 0,
      recommendCodeVisible: false,
      tipContent: "",
      plusCardIdList:[], //选择的卡
      normalPlusCardInfo:[],
      currentTime: new Date(), // 当前时间
      rightsProgressDialogVisible: false, // 权益明细弹框
      rightsProgressRow: {}, // 权益明细当前会员
      isRightsProgressOutputing: false, // 权益明细导出中
      expandedCardKeys: [], // 默认展开的卡
      expandedRightKeys: [] // 默认展开的权益
    };
  },
  computed: {
    ...mapGetters(["plusMemberList", "rightsProgress"]),
    finalRecommendCodeList() {
      if(this.recommendCodeList && this.recommendCodeList.length) {
        const pageNo = this.recommendCodeCondition.pageNo
        const pageSize = this.recommendCodeCondition.pageSize
        return this.recommendCodeList.slice((pageNo - 1) * pageSize, pageNo * pageSize);
      } else {
        return []
      }
    }
  },
  watch: {},
  created() {
    this.basic_plus_rule_list();
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    if (
      this.storeCode === "53010017032439" ||
      this.storeCode === "53010101062655"
    ) {
      this.isHasHuaChuang = true;
    }
    if (this.storeCode === "53010017032439") {
      this.isDengkang = true;
    }
  },
  mounted() {
    this.searchCondition.createTimeArry = [
      moment(new Date()).format("YYYY-MM-DD") + " 00:00:00",
      moment(new Date()).format("YYYY-MM-DD") + " 23:59:59",
    ];
    this.getParamsCookie();
    if (this.$route.query.time) {
      this.searchCondition.createTimeArry = JSON.parse(this.$route.query.time);
    }
    this.getTime().then(res => {
      if (res && res.now) {
        this.currentTime = new Date(res.now);
      }
    });
    this.queryList();
    this.queryExclusiveList();
  },
  methods: {
    /**
     * @desc 判断是否有联名卡
     */
    hasJointCards(plusCardInfo) {
      console.log('plusCardInfo:', plusCardInfo)
      if (!plusCardInfo || plusCardInfo.length === 0) return false;
      const basicCards = plusCardInfo.filter(card => card.cardType === 'basic');
      const today = new Date();
      const todayStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
      for (const basicCard of basicCards) {
        const relatedJointCards = this.getRelatedJointCards(basicCard, plusCardInfo);
        // 过滤掉开卡时间是当天的联名卡
        const validJointCards = relatedJointCards.filter(card => {
          const cardStartDate = card.cardTermStartTime ? card.cardTermStartTime.split(' ')[0] : '';
          return cardStartDate !== todayStr;
        });
        if (validJointCards.length > 0) {
          return true;
        }
      }
      return false;
    },
    async getTime() {
      const result = await this.$store.dispatch("post", {
        url: '/provider/tenant/providerInfo/getInfo',
        hideLoading: false
      });
      return result;
    },
    async basic_plus_rule_list() {
      //卡规则列表查询
      const { result } = await this.$store.dispatch("basic_plus_rule_list",{pageNo: 1, pageSize: 999});
      this.basic_plus_rule_lists = result.records;
    },
    async toDetails(row) {
      this.centerId = row.centerId;
      this.row = row;
      await this.queryDetailList();
      this.detailsModalVisible = true;
      const { result } = await this.$store.dispatch("queryAllLabel", {
        centerId: row.centerId,
      });
      this.allLabelList = result;
      let memberMgt = await this.$store.dispatch("detailsMemberMgt", {
        centerId: row.centerId,
      });
      console.log("memberMgt: ", memberMgt);
      // this.$store
      //   .dispatch("detailsMemberMgt", {
      //     centerId: row.centerId
      //   })
      //   .then(res => {
      //     if (res.code == "0") {
      //       this.detMemberMgt = res.result;
      //       res.result.cardInfoVoList.forEach(v => {
      //         if (v.isMasterCard == "yes") {
      //           this.defaultCardId = v.memberCardId;
      //         }
      //       });
      //     }
      //   });
    },
    pagingLog(page) {
      this.currentPageLog = page;
      this.queryLogList();
    },
    handleSizeChangeLog(size) {
      this.currentPageLog = 1;
      this.pageSizeLog = size;
      this.queryLogList();
    },
    async queryLogList() {
      let params = {
        pageSize: this.pageSizeLog,
        pageNo: this.currentPageLog,
        bizDataPk: this.row.centerId,
        bizType: "plusCard",
      };
      const { result } = await this.$store.dispatch(
        "storeOperationLogList",
        params
      );
      this.logList = result.records;
      this.totalLog = result.total;
    },
    operationLog(row) {
      this.dialogVisibleLog = true;
      this.row = row;
      this.pageSizeLog = 10;
      this.currentPageLog = 1;
      this.queryLogList();
    },
    async assistantChange(row) {
      const { code } = await this.$store.dispatch("addMemberAssistant", {
        centerId: row.centerId,
        assistant: row.assistant,
      });
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        this.queryList();
      }
    },
    async queryExclusiveList() {
      let params = {
        dictCode: "plus_assistant",
      };
      const { code, result } = await this.$store.dispatch(
        "queryActTypeList",
        params
      );

      if (code === "0" && result) {
        this.plusAssistant = result.sysDictItem;
      }
    },
    checkedCoupons(val) {
      this.couponsCodes = val;
      let arr = [];
      val.forEach((e) => {
        arr.push(e.couponId);
      });
      this.couponIdList = arr;
      console.log("this.couponIdList:" + this.couponIdList);
      console.log(this.couponsCodes);
    },
    async confirm() {
      if (this.checkCouponsList.length > 0) {
        let params = {
          couponInfoList: this.checkCouponsList,
        };
        Object.assign(params, this.row);
        const { code } = await this.$store.dispatch("balanceRefund", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.queryList();
        }
      } else {
        this.$message({
          message: "请选择需要退回的优惠券!",
          type: "warning",
        });
      }
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then((res) => {
            const list = res.result.records;
            list.forEach((v) => {
              if (v.cardStatus === "0") {
                v.cardStatus = "注销";
              } else if (v.cardStatus === "1") {
                v.cardStatus = "正常";
              } else if (v.cardStatus === "2") {
                v.cardStatus = "冻结";
              }
              let endTime =
                new Date(v.cardTermEndTime).getTime() / 1000 -
                parseInt(new Date().getTime() / 1000);
              v.timeDay = parseInt(endTime / 60 / 60 / 24);
              if (v.timeDay < 0) {
                v.timeDay = "已过期";
              }
              v.plusCardInfo = v.plusCardInfoJson
                ? JSON.parse(v.plusCardInfoJson)
                : [];
              const cardTermEndTimeList = v.plusCardInfo.map((v) =>
                new Date(v.cardTermEndTime).getTime()
              );
              const max = Math.max.apply(null, cardTermEndTimeList);
              const now = new Date().getTime();
              v.cardEndDate = moment(max).format("YYYY-MM-DD HH:mm:ss");
              v.timeDay = Math.round((max - now) / 1000 / 60 / 60 / 24);
            });
            // const tHeader = this.$refs.table.columns
            //   .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
            //   .filter(o => o);

            // let filterVal = [];
            // if (list.length > 0) {
            //   filterVal = this.$refs.table.$children
            //     .map(o => o._props.prop)
            //     .filter(o => o);
            // }

            const tHeader = [
              "PLUS卡号",
              "会员姓名",
              "会员手机号",
              "宝宝生日",
              "剩余时间(天)",
              "开卡时间",
              "到期时间",
              "购卡费用",
              "本月剩余额度",
              "PLUS状态",
              "开卡累计消费",
              "卡规则名称",
            ];

            const filterVal = [
              "cardNo",
              "realName",
              "mobile",
              "babyBirthday",
              "timeDay",
              "cardTermStartTime",
              "cardEndDate",
              "openCardFee",
              "couponBalance",
              "cardStatus",
              "totalConsumeAmount",
              "plusCardInfoJson.plusCardName",
            ];

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "PLUS会员列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    // 导出excel---后台导出
    outputNew() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.openCardStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.openCardEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      searchCondition.cardStartTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[0]
          : null;
      searchCondition.cardEndTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[1]
          : null;
      //Object.assign(params, searchCondition);
      this.$store.dispatch("plusAllMemberListOutput", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    exportPlusOrder(type) {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.openCardStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.openCardEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      if (
        !searchCondition.openCardStartTime ||
        !searchCondition.openCardEndTime
      ) {
        this.$message({
          message: "请选择会员开卡时间",
          type: "warning",
        });
        return;
      }
      if (
        Date.parse(searchCondition.openCardEndTime) -
          Date.parse(searchCondition.openCardStartTime) >
          31 * 24 * 60 * 60 * 1000 ||
        Date.parse(searchCondition.openCardStartTime) >
          Date.parse(searchCondition.openCardEndTime)
      ) {
        this.$message({
          message: "导出时间范围不能超过1个月",
          type: "warning",
        });
        return;
      }

      //Object.assign(params, searchCondition);
      searchCondition.type = type;
      if (type == "plusOrderDetail") {
        searchCondition.exportName = "导出PLUS会员订单明细";
      } else if (type == "plusCouponOrderDetail") {
        searchCondition.exportName = "导出PLUS消费返利订单明细";
      }
      console.log("searchCondition:", searchCondition);
      this.$store.dispatch("export", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryCouponsList() {
      let params = {
        pageSize: this.pageSizeCoupons,
        pageNo: this.currentPageCoupons,
        centerId: this.row.centerId,
      };

      const { result } = await this.$store.dispatch("queryUnusedList", params);
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.pageSize = 99999;
      searchCondition.pageNo = 1;
      searchCondition.openCardStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.openCardEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      searchCondition.cardStartTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[0]
          : null;
      searchCondition.cardEndTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      return this.$store.dispatch("plusAllMemberList", params);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.openCardStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.openCardEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      searchCondition.cardStartTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[0]
          : null;
      searchCondition.cardEndTime =
        this.searchCondition.endTimeArry &&
        this.searchCondition.endTimeArry.length > 0
          ? this.searchCondition.endTimeArry[1]
          : null;
      Object.assign(params, searchCondition);

      // 添加校验逻辑：三个查询条件中必须至少有一个有值
      const hasCreateTime = this.searchCondition.createTimeArry && this.searchCondition.createTimeArry.length > 0;
      const hasEndTime = this.searchCondition.endTimeArry && this.searchCondition.endTimeArry.length > 0;
      const hasKeyWords = this.searchCondition.keyWords && this.searchCondition.keyWords.trim() !== '';
      
      if (!hasCreateTime && !hasEndTime && !hasKeyWords) {
        this.$message({
          message: "开卡时间段、到期时间段和关键词三个条件中至少填写一个！",
          type: "warning"
        });
        return Promise.reject(new Error("查询条件不足"));
      }

      this.setParamsCookie();
      return this.$store.dispatch("plusMemberList", params);
},
    setParamsCookie() {
      setCookie({
        key: "plusMemberListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "plusMemberListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingCoupons(page) {
      this.currentPageCoupons = page;
      this.queryCouponsList();
    },
    pagingCoupons2(page) {
      console.log("page:" + page);
      this.currentPageCoupons = page;
      this.couponList();
    },
    handleSizeChange2(size) {
      console.log("size:" + size);
      this.currentPageCoupons = 1;
      this.pageSizeCoupons = size;
      this.couponList();
    },
    handleSizeChangeCoupons(size) {
      this.currentPageCoupons = 1;
      this.pageSizeCoupons = size;
      this.queryCouponsList();
    },
    queryDetails(row) {
      this.centerId = row.centerId;
      this.visible = true;
    },
    toDetails(row) {
      this.dialogVisible = true;
      this.row = row;
      this.queryCouponsList();
    },
    transfer(row) {
      this.type = "transfer";
      this.remark = "";
      this.mobile = "";
      this.dialogVisibleRights = true;
      this.row = row;
    },
    cancelRights(row) {
      this.plusCardIdList = []
      this.centerId = row.centerId;
      this.type = "cancelRights";
      this.remark = "";
      this.mobile = "";
      this.dialogVisibleRights = true;
      this.row = row;
      this.queryDetails2();
      //禾苗42010216070190 和 爱特欧巴42010212127038
      if (
        row.storeCode === "42010216070190" ||
        row.storeCode === "42010212127038"
      ) {
        this.dialogVisibleLabelList = true;
      }else{
        this.dialogVisibleLabelList = false;
      }
    },
    countDown() {
      setInterval(() => {
        this.list.forEach((v) => {
          let aaa = new Date(v.endDate).getTime();

          let bbb = new Date().getTime();
          let rightTime = aaa - bbb;

          if (rightTime > 0) {
            var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
            var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
            var mm = Math.floor((rightTime / 1000 / 60) % 60);
            var ss = Math.floor((rightTime / 1000) % 60);
          }
          v.djs = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
        });
      }, 1000);
    },
    async couponList() {
      let params = {
        pageSize: this.pageSizeCoupons,
        pageNo: this.currentPageCoupons,
        memberMobile: this.row.mobile,
        keyword: "",
        verifyCode: "",
        verifyMoney: "",
        verifyType: "coupon",
      };
      const { result } = await this.$store.dispatch(
        "queryByVerifyCode",
        params
      );
      const { records, total } = result.list;
      records.forEach((v) => {
        this.$set(v, "djs", InitTime(v.endDate));
      });
      console.log(result);
      console.log("this.pageNo:", this.currentPageCoupons);
      console.log("this.pageSize:", this.pageSizeCoupons);
      this.list = records;
      this.total = total;
      this.countDown();
    },
    async openCoupon(v) {
      this.title = `券名:${v.name}`;
      this.couponCode = v.couponCode;
      this.dialogVisible2 = true;
      let params = {
        couponCode: v.couponCode,
        centerId: v.memberId,
      };
      const { code } = await this.$store.dispatch("writeCouponRule", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }
    },
    // async searchMember() {
    //   let params = {
    //     mobile: this.mobile,
    //     plusCardId: this.row.plusCardId
    //   };
    //   if (this.couponsCodes.length > 0) {
    //   params = {
    //     mobile: this.mobile,
    //     plusCardId: this.row.plusCardId,
    //     centerId: this.row.centerId,
    //     remarks: this.remark,
    //     // couponInfoList: this.couponIdList

    //   };
    //   const { result, code, errMsg } = await this.$store.dispatch(
    //     "rightMoveDo",
    //     params
    //   );
    //   if (code === "0") {
    //     this.innerVisible = true;
    //     this.code = result;
    //     this.errmsg = errMsg;
    //   }
    //   } else {
    //       this.$message({
    //         message: "请选择优惠券!",
    //         type: "warning"
    //       });
    //   }
    // },
    async searchMember() {
      if (!this.mobile) {
        this.$message({
          message: "请输入手机号!",
          type: "warning",
        });
        return;
      }
      if (!/^1[0-9]{10}$/.test(this.mobile)) {
        this.$message({
          message: "请输入正确的手机号!",
          type: "warning",
        });
        return;
      }
      let params = {
        mobile: this.mobile,
        plusCardId: this.row.plusCardId,
        pageNo: 1,
        currentPageCoupons: 1,
      };
      const { result, code, errMsg } = await this.$store.dispatch(
        "rightMove",
        params
      );
      if (code === "0") {
        this.innerVisible = true;
        this.code = result;
        this.errmsg = errMsg;
        this.couponInfoList = [];
        this.couponList();
      }
    },
    cleanData(){
       this.$refs.multipleTable.clearSelection();
    },
    async confirmTransfer() {
      if (this.type === "transfer") {
        if (!this.mobile) {
          this.$message({
            message: "请输入手机号!",
            type: "warning",
          });
          return;
        }
        if (!/^1[0-9]{10}$/.test(this.mobile)) {
          this.$message({
            message: "请输入正确的手机号!",
            type: "warning",
          });
          return;
        }
        let params = {
          mobile: this.mobile,
          plusCardId: this.row.plusCardId,
          centerId: this.row.centerId,
          remarks: this.remark,
          couponInfoList: this.couponsCodes
        };
        if (this.isDengkang) {
          Object.assign(params, { moveConsumeInfo: this.moveConsumeInfo });
        }
        const { code } = await this.$store.dispatch("rightMoveDo", params);
        if (code === "0") {
          this.innerVisible = false;
          this.dialogVisibleRights = false;
          this.mobile = "";
          this.remark = "";
          this.couponInfoList = [];
          this.couponsCodes = [];
          this.checkCouponsList = [];
          (this.pageNo = 1), (this.currentPageCoupons = 1);
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
        }
      } else if (this.type === "cancelRights") {
        console.log("this.labelInfoVosList:", this.labelInfoVosList);
        console.log(this.row)
        if (this.plusCardIdList.length == 0) {
          this.$message({
            message: "请至少选择一张会员卡!",
            type: "warning",
          });
          return;
        }
        let params = JSON.parse(JSON.stringify(this.row));
        params.remarks = this.remark;
        params.lableIdList = this.labelInfoVosList;
        params.plusCardIdList = this.plusCardIdList;
        console.log("params:", params);
        const { code, result } = await this.$store.dispatch(
          "rightCancel",
          params
        );

        if (code === "0") {
          if (result) {
            this.cancelCardInfo = result;
            this.cancelVisible = true;
          }
          this.dialogVisibleRights = false;
          this.remark = "";
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
        }
      }
    },
    async queryDetails2() {
      const { result } = await this.$store.dispatch("queryAllLabel", {
        centerId: this.centerId,
      });
      this.allLabelList = result;
      this.$store
        .dispatch("detailsMemberMgt", {
          centerId: this.centerId,
        })
        .then((res) => {
          if (res.code == "0") {
            this.detMemberMgt = res.result;
            res.result.cardInfoVoList.forEach((v) => {
              if (v.isMasterCard == "yes") {
                this.defaultCardId = v.memberCardId;
              }
            });
            this.normalPlusCardInfo = res.result.normalPlusCardInfo
            this.tipContent = res.result.isPlusRecommend
          }
        });
    },
    moveConsumeInfoListChange(e) {
      if (this.moveConsumeInfoList.length) {
        this.moveConsumeInfo = "yes";
      } else {
        this.moveConsumeInfo = "no";
      }
      console.log("this.moveConsumeInfo:", this.moveConsumeInfo);
    },
    /**
     * @desc 显示推荐记录
     */
    async showRecommendCode(row) {
      await this.getRecommendCodeList(row);
      this.recommendCodeVisible = true;
    },
    /**
     * @desc 查询推荐码列表
     */
    async getRecommendCodeList(row) {
      const { result, code, errMsg } = await this.$store.dispatch(
        "getRecommendCodeList",
        {
          recPlusCardId: row.plusCardId,
        }
      );
      console.log("---result---", result);
      if (code === "0") {
        this.recommendCodeList = result.records;
        this.recommendCodeTotal = result.total;
      }
    },
    /**
     * @desc 推荐码翻页
     */
    pagingRecommendCode(val) {
      this.recommendCodeCondition.pageNo = val;
      this.getRecommendCodeList();
    },
    /**
     * @desc 推荐码pageSize调整
     */
    handleSizeChangeRecommendCode(val) {
      this.recommendCodeCondition.pageNo = 1;
      this.recommendCodeCondition.pageSize = val;
      this.getRecommendCodeList();
    },
    // 选择会员卡
    handleSelectionChange(val) {
      this.plusCardIdList = []
      console.log(val)
      if(val.length>0){
        val.forEach((item)=>{
          this.plusCardIdList.push(item.plusCardId)
        })
      }
    },
    // 判断会员卡时间状态
    getCardTimeStatus(startTime, endTime) {
      const now = this.currentTime;
      const start = new Date(startTime);
      const end = new Date(endTime);
      
      if (now > end) {
        return 'expired'; // 已过期
      } else if (now >= start && now <= end) {
        return 'current'; // 当前
      } else {
        return 'future'; // 未来
      }
    },
    // 获取与PLUS卡相关的联名卡
    getRelatedJointCards(plusCard, plusCardInfo) {
      const plusStart = new Date(plusCard.cardTermStartTime);
      const plusEnd = new Date(plusCard.cardTermEndTime);
      
      return plusCardInfo.filter(card => {
        if (card.cardType === 'increase') {
          const jointStart = new Date(card.cardTermStartTime);
          // 联名卡的开始时间应该在当前PLUS卡的有效期内
          return jointStart >= plusStart && jointStart <= plusEnd;
        }
        return false;
      });
    },
    // 按cardTermStartTime排序PLUS卡
    sortedPlusCards(plusCardInfo) {
      return plusCardInfo
        .filter(card => card.cardType === 'basic')
        .sort((a, b) => new Date(a.cardTermStartTime) - new Date(b.cardTermStartTime));
    },
    /**
     * @desc 查看会员权益明细
     */
    async showRightsProgress(row) {
      try {
        const { code } = await this.$store.dispatch("queryMemberRightsProgress", {
          phone: row.mobile,
          storeCode: row.storeCode,
        });
        if (code === "0") {
          this.rightsProgressRow = row;
          this.setRightsProgressDefaultExpand();
          this.rightsProgressDialogVisible = true;
        }
      } catch (err) {
        this.rightsProgressDialogVisible = false;
      }
    },
    /**
     * @desc 默认展开第一张卡的第一个权益
     */
    setRightsProgressDefaultExpand() {
      const cards = this.rightsProgress.cards || [];
      if (cards.length === 0) {
        this.expandedCardKeys = [];
        this.expandedRightKeys = [];
        return;
      }
      this.expandedCardKeys = [cards[0].cardId];
      const firstRights = cards[0].rights || [];
      this.expandedRightKeys = firstRights.length > 0 ? [firstRights[0].name] : [];
    },
    /**
     * @desc 导出权益明细
     */
    exportRightsProgress() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const cards = this.rightsProgress.cards || [];
        const rows = [];
        cards.forEach(card => {
          const rights = card.rights || [];
          if (rights.length === 0) {
            rows.push({
              cardName: card.cardName,
              status: card.status,
              memberName: card.memberName,
              store: card.store,
              guide: card.guide,
              validity: (card.termStart || "") + " 至 " + (card.termEnd || ""),
              name: "",
              target: "",
              goodsCount: "",
              goodsAmount: "",
              couponCount: ""
            });
          } else {
            rights.forEach(r => {
              rows.push({
                cardName: card.cardName,
                status: card.status,
                memberName: card.memberName,
                store: card.store,
                guide: card.guide,
                validity: (card.termStart || "") + " 至 " + (card.termEnd || ""),
                name: r.name,
                target: r.target,
                goodsCount: r.goodsCount,
                goodsAmount: r.goodsAmount,
                couponCount: r.couponCount
              });
            });
          }
        });
        const tHeader = ["联名卡", "卡状态", "会员姓名", "归属门店", "专属管家", "联名卡效期", "权益名称", "目标件数", "累计商品数量", "累计商品金额", "已派券数量"];
        const filterVal = ["cardName", "status", "memberName", "store", "guide", "validity", "name", "target", "goodsCount", "goodsAmount", "couponCount"];
        const data = this.formatJson(filterVal, rows);
        exportJsonToExcel(tHeader, data, "PLUS会员联名卡权益明细" + new Date().toLocaleString());
      });
    }
  },
};
</script>
<style lang="scss" scoped>
/* 会员卡时间状态样式 */
.expired {
  color: #909399; // 灰色 - 已过期
}
.current {
  color: #28a745; // 深绿色 - 当前
}
.future {
  color: #ffc107; // 亮黄色 - 未来
}

.card-item {
  margin-bottom: 10px;
}

.plus-card {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.card-header {
  display: flex;
  margin-bottom: 5px;
}

.card-type {
  font-weight: bold;
  margin-right: 10px;
  color: #303133;
}

.card-name {
  color: #606266;
}

.card-content {
  margin-left: 60px;
}

.card-validity {
  font-size: 14px;
}

.joint-cards {
  margin-top: 10px;
  margin-left: 20px;
}

.joint-card-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  margin-top: 5px;
  background-color: #ffffff;
}

.list-item {
  width: 440px;
  // margin: 0 auto;
  margin-left: 100px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .list-box {
    box-sizing: border-box;
    box-shadow: 0px 0px 43px 0px rgba(197, 197, 197, 0.43);
    border-radius: 6px;
    &.act0 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/0.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act1 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/1.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act2 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/2.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act3 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/3.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act4 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/4.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
    &.act5 {
      background-image: url(https://imgcdn.hemiao100.com/ThemePictures/5.png);
      background-size: 60px;
      background-repeat: no-repeat;
      background-position: 100% 0;
    }
  }
  .list-left {
    width: 125px;
    height: 100%;
    background-color: #fcca8e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .zhekou {
      font-size: 22px;
      text-align: center;
    }

    .tiaojian {
      font-size: 12px;
      margin-top: 10px;
      text-align: center;
    }
  }
  .list-right {
    .right-top {
      padding: 16px;
      .right-title {
        font-size: 16px;
        font-weight: 600;
        width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .right-time {
        color: #909090;
        margin-top: 6px;
      }
      .remaining-time {
        color: red;
      }
    }
  }
  .circle1 {
    position: absolute;
    z-index: 5;
    top: -5px;
    left: 25px;
    transform-origin: center left;
    transform: rotate(90deg);
    width: 110px;
    height: 9px;
    background-image: radial-gradient(
      circle,
      #fcca8e,
      #fcca8e 4px,
      transparent 0px,
      transparent 2px,
      transparent 22px,
      transparent
    );
    background-size: 10px 10px;
    background-repeat: repeat-x;
  }
}
.TransferAmount {
  font-size: 18px;
}
.tips_02 {
  color: #999999;
}
.transfer-list {
  font-size: 16px;
  line-height: 24px;
  .left {
    text-align: right;
    width: 200px;
    display: inline-block;
  }
  .right {
    margin-left: 20px;
    text-align: left;
    width: 400px;
    display: inline-block;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  width: 15%;
}
</style>
